import {useMemo} from 'react';

import {useGetWeeklyChallengeListQuery} from '~/store/rtkQuery';

export const useGetWeeklyChallengeList = () => {
  const {
    data: challengeList,
    isLoading,
    error,
    isError,
  } = useGetWeeklyChallengeListQuery();

  const downloadingChallengeListStatus = useMemo<
    'none' | 'requesting' | 'success' | 'error'
  >(() => {
    if (isLoading) return 'requesting';
    if (isError) return 'error';
    if (challengeList) return 'success';
    return 'none';
  }, [isLoading, isError, challengeList]);

  const downloadingChallengeListErrorMsg = useMemo(() => {
    if (error && 'message' in error) {
      return error.message as string;
    }
    return '';
  }, [error]);

  return {
    downloadingChallengeListErrorMsg,
    downloadingChallengeListStatus,
    challengeList,
  };
};
